import { Box } from '@mui/material';
import { Request } from 'domain/shared/oneStop';
import OneStopSearchResults from 'domain/gpo/oneStop/List/OneStopSearchResults';
import { useListContext } from 'framework/list';
import { ShowContextProvider, ShowData } from 'framework/show';
import { Alert } from 'framework/ui/mui-builder';

type OneStopSearchResultsLayoutProps = {
  setFocusToResults: () => void;
  focusedResultIndex: Nullable<Number>;
  searchResultsRefs: HTMLAnchorElement[];
  onKeyUp: (event: any, index: number) => void;
};

const OneStopSearchResultsLayout = ({
  onKeyUp,
  searchResultsRefs,
  focusedResultIndex,
  setFocusToResults,
}: OneStopSearchResultsLayoutProps) => {
  const { data: { items = [] } = {} } = useListContext();

  return (
    <Box>
      {items.length ? (
        items.map((row: Request, index: number) => (
          <ShowContextProvider
            key={row.id}
            value={{
              data: new ShowData(row),
            }}
          >
            <OneStopSearchResults
              row={row}
              index={index}
              onKeyUp={onKeyUp}
              focusedResultIndex={focusedResultIndex}
              setFocusToResults={setFocusToResults}
              searchResultsRefs={searchResultsRefs}
            />
          </ShowContextProvider>
        ))
      ) : (
        <Alert color="info" sx={{ mt: 1.5 }}>
          No results were found.
        </Alert>
      )}
    </Box>
  );
};

export default OneStopSearchResultsLayout;
